import { useTranslation } from 'react-i18next';
import projects from '../../data/projects';
import BoxItem from '../BoxItem';
import useInView from '../../hooks/useInView';
import Carousel from 'react-multi-carousel';
import { responsiveCarousel } from '../../config/consts';
import 'react-multi-carousel/lib/styles.css';

const Projects = () => {
    const { i18n, t } = useTranslation();
    const isRtl = i18n.language === 'he';
    const [ref, isInView] = useInView();

    const renderProject = () => {
        return projects.map((item) => (
            <BoxItem
                key={item._id}
                title={t(item.title)}
                subtitle={t(item.subtitle)}
                description={t(item.description)}
                link={item.link}
                appStoreLink={item.appStoreLink}
                googlePlayLink={item.googlePlayLink}
                thumbnail={t(item.thumbnail)}
                containImages={item.images && item.images.length > 0}
                images={item.images}
                inProgress={item.inProgress}
                isMobileApp={item.isMobileApp}
            />
        ));
    };

    return (
        <section id='projects'>
            <div className='container-xxl' ref={ref}>
                <div className='text-center'>
                    <h3 className='section-title'>
                        <span className={`${isRtl ? 'text-primary' : 'text-tertiary'}`}>
                            {t('projects-title.part1')}
                        </span>
                        <span className={`${isRtl ? 'text-tertiary' : 'text-primary'}`}>
                            {t('projects-title.part2')}
                        </span>
                    </h3>
                </div>
                <div className={isInView ? 'fade-up' : ''}>
                    <Carousel
                        responsive={responsiveCarousel}
                        infinite={true}
                        showDots={true}
                        removeArrowOnDeviceType={['mobile']}
                    >
                        {renderProject()}
                    </Carousel>
                </div>
            </div>
        </section>
    );
};

export default Projects;
